import classnames from 'classnames'
import { useState } from 'react'

import { Button, Image } from '@/components'

export const TeslaAccountIdGuide = () => {
    const [isExpanded, setisExpanded] = useState(false)
    const [isImageZoomedIn, setIsImageZoomedIn] = useState(false)

    return <div
        className={classnames(
            'transition-colors flex flex-col xl:flex-row gap-4',
            { 'px-6 py-4 rounded bg-gray-100': isExpanded }
        )}
    >
        <div className="flex flex-col items-start gap-5">
            <Button
                design="btn-link"
                className="text-primary-800"
                type="button"
                onClick={() => setisExpanded(!isExpanded)}
            >
                How To Find Your Tesla Account ID
            </Button>

            {isExpanded && <ul className="text-xs list-decimal ml-4 leading-5 animate-fade-in xl:whitespace-nowrap">
                <li>
                    <a
                        className="text-primary-600 underline"
                        href="https://powerhub.energy.tesla.com/login"
                        target="_blank"
                    >
                        Log into Tesla Powerhub
                    </a>
                </li>
                <li>
                    On the Dashboard, navigate to
                    the <span className="font-semibold">"Access & Security"</span> tab on the left.
                </li>
                <li>
                    Expand the <span className="font-semibold">"User Access"</span> dropdown.
                </li>
                <li>
                    Your Tesla Account ID will be displayed at the bottom of the dropdown.
                </li>
            </ul>}
        </div>

        {isExpanded && <button
            onClick={() => setIsImageZoomedIn(!isImageZoomedIn)}
            type="button"
        >
            <Image
                src="/assets/images/gifs/tesla-account-id-guide.png"
                alt="Tesla Account ID Guide"
                className={classnames(
                    'animate-fade-in transition-all max-w-full',
                    isImageZoomedIn ? 'w-full cursor-zoom-out' : 'w-100 cursor-zoom-in'
                )}
            />
        </button>}
    </div>
}
